import { render, staticRenderFns } from "./TabsWithBlocks.vue?vue&type=template&id=d6edcda6&scoped=true&"
import script from "./TabsWithBlocks.vue?vue&type=script&lang=ts&"
export * from "./TabsWithBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./TabsWithBlocks.vue?vue&type=style&index=0&id=d6edcda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6edcda6",
  null
  
)

export default component.exports